import axios from 'axios'

export default {
    namespaced: true,
    state: {
    },
    getters: {
    },
    mutations: {
    },
    actions: {
        fetch({commit, dispatch}, filter) {
            commit('TOGGLE_PRELOADER', true, {root: true})
            return new Promise((resolve) => {
                axios.get(
                    '/api/spa-manager/orders/list',
                    { params: filter}
                ).finally(() => {
                    commit('TOGGLE_PRELOADER', false, {root: true})
                }).then(({data}) => {
                    resolve(data.data)
                }).catch((error) => {
                    dispatch('checkUnauthenticated', error, { root: true })
                })
            })
        },
        edit({dispatch}, editedItem) {
            return new Promise((resolve) => {
                axios.post(
                    '/api/spa-manager/orders/edit/' + editedItem.id,
                    prepareData(editedItem)
                ).then(({data}) => {
                    resolve(data.data)
                }).catch((error) => {
                    dispatch('checkUnauthenticated', error, { root: true })
                })
            })
        },
        add({dispatch}, editedItem) {
            return new Promise((resolve) => {
                axios.post(
                    '/api/spa-manager/orders/add',
                    prepareData(editedItem)
                ).then(({data}) => {
                    resolve(data.data)
                }).catch((error) => {
                    dispatch('checkUnauthenticated', error, { root: true })
                })
            })
        },
        complete({dispatch}, orderId) {
            return new Promise((resolve) => {
                axios.put('/api/spa-manager/orders/complete/' + orderId).then(() => {
                    resolve()
                }).catch((error) => {
                    dispatch('checkUnauthenticated', error, { root: true })
                })
            })
        },
        cancel({dispatch}, payload) {
            return new Promise((resolve) => {
                axios.delete('/api/spa-manager/orders/cancel/' + payload.id, {
                    params: { text: payload.text }
                }).then(({data}) => {
                    resolve(data.data)
                }).catch((error) => {
                    dispatch('checkUnauthenticated', error, { root: true })
                })
            })
        },
        completedFetchClient({commit, dispatch}, filter) {
            commit('TOGGLE_PRELOADER', true, {root: true})
            return axios.get(
                '/api/manager/service-orders/complete/list',
                { params: filter}
            ).finally(() => {
                commit('TOGGLE_PRELOADER', false, {root: true})
            }).catch((error) => {
                dispatch('checkUnauthenticated', error, { root: true })
            })
        },
        completedFetchConsolidated({commit, dispatch}, filter) {
            commit('TOGGLE_PRELOADER', true, {root: true})
            return axios.get(
                '/api/manager/service-orders/complete/consolidated',
                { params: filter}
            ).finally(() => {
                commit('TOGGLE_PRELOADER', false, {root: true})
            }).catch((error) => {
                dispatch('checkUnauthenticated', error, { root: true })
            })
        }
    }
}

function prepareData (data) {
    return {
        status: data.status,
        spa_service_id: data.spa_service_id,
        client_id: data.client_id,
        spa_salon_id: data.spa_salon_id,
        price: data.price,
        time_preparing: data.time_preparing
    }
}

